import React, { useState, useContext } from "react";
import {CookieNotice} from "gatsby-cookie-notice";
import {
	useTheme,
	Box,
} from "@mui/material";
import { SiteContext } from "gatsby-frontend";


function CookieAgreement() {
	const theme = useTheme();
	// const [agreed, setAgreed] = useState(false);
	const { cookiesText, cookiesTitle, showCookieNotice, cookiegdpr } =
		useContext(SiteContext);
	let showCookie = (cookiegdpr && showCookieNotice);
	let subtitle = cookiesTitle ? cookiesTitle : "Cookie Agreement";
	let innertext = cookiesText
		? cookiesText
		: "We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume consent of cookies on our website.";
	// const agreeCookies = async () => {
	// 	try {
	// 		setSubmitting(true);
	// 		if (agreed) {
	// 			setAgreed(false);
	// 		} else {
	// 			setAgreed(true);
	// 		}
	// 		setSubmitting(false);
	// 	} catch (e) {
	// 		setSubmitting(false);
	// 	}
	// };

	return (
		<>
			{showCookie && (
				<Box
					component="div"
					className="colophon"
					sx={{
						"& .bg-cookie": {
							position: "fixed",
							bottom: 0,
							left: 0,
							backgroundColor: theme.palette.body.contrastText,
              opacity: 0.89,
							color: theme.palette.body.main,
							width: "100%",
							padding: theme.spacing(2),
							zIndex: 1000,
						},
            "& .btn": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              padding: theme.spacing(1, 2),
              borderRadius: theme.spacing(0.4),
              border: "none",
            },
            "& .btnhide": {
              display: "none",
            },
            "& .text": {
              "& h4": {
                margin: 0,
              },
              "& p": {
                margin: 0,
              },
            },
					}}
				>
					<CookieNotice
						personalizeButtonEnabled={false}
						declineButton={false}
						personalizeButton={false}
            personalizeButtonClasses="btn btnhide"
						cookies={[
							{
								name: "necessary",
								editable: false,
								default: true,
								title: "Strictly Necessary Cookies Only",
								text: "These cookies are necessary for our website to function properly. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms or where they’re essential to provide you with a service you have requested. These cookies do not store any personally identifiable information.",
							},
						]}
					>
            <Box
            dangerouslySetInnerHTML={{ __html: `<h4>${subtitle}</h4> ${innertext}` }}
            className="text"
            >
            </Box>
					</CookieNotice>
				</Box>
			)}
		</>
	);
}

export default CookieAgreement;